import { render, staticRenderFns } from "./CustomBooking.vue?vue&type=template&id=16412678&"
import script from "./CustomBooking.vue?vue&type=script&lang=js&"
export * from "./CustomBooking.vue?vue&type=script&lang=js&"
import style0 from "./CustomBooking.vue?vue&type=style&index=0&id=16412678&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports